import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { Typography } from "@material-ui/core";
import Modal from "react-modal";
import { Link } from "@material-ui/core";
import * as theme from "../theme";
import quoteyLogo from "../logos/common/quotey-logo.svg";
import CancelIcon from "@material-ui/icons/Cancel";
import { useDispatch, useSelector } from "react-redux";
import { loginModalClosed, signUpModalClosed } from "../store/components";
import PerfectScrollbar from "react-perfect-scrollbar";
import Sample from "./signup/Sample";
import "./Login.css";
import {
  loginBroker,
  getJWT,
  verifyToken,
  getLoginAttemptSuccess,
  brokerLoggedOut,
  getUserRoles,
  getProvinces,
  getIsTwoFARequired,
  getBrokerInformation,
  getLanguagePreference,
} from "../store/broker";
import {
  updateDetails,
  updateUserLanguagePreference,
  updateLanguagePreference,
  getUserLanguagePreference,
} from "../store/userManagement";
import { getSignUpModalState, signUpModalOpened } from "../store/components";
import { useNavigate } from "react-router-dom";
import translations from "../utils/translations";
import StytchB2BLogin from './StytchB2BLogin'; // Import the new component


const Login = (props) => {
  const [username, setUsername] = useState(null);
  const [password, setPassword] = useState(null);
  const dispatch = useDispatch();
  const history = useNavigate();

  const loginAttemptSuccess = useSelector(getLoginAttemptSuccess);
  const isTwoFARequired = useSelector(getIsTwoFARequired);
  const signUp = useSelector(getSignUpModalState);
  // Use localStorage for language preference since user is not authenticated yet
  const [languagepreference, setLanguagePreference] = useState(() => {
    return localStorage.getItem('language') || sessionStorage.getItem('language') || 'en';
  });

  // Update language preference when it changes in storage or from other components
  useEffect(() => {
    const handleStorageChange = (e) => {
      if (e.key === 'language') {
        setLanguagePreference(e.newValue || 'en');
      }
    };

    const handleLanguageChange = (e) => {
      setLanguagePreference(e.detail || 'en');
    };

    window.addEventListener('storage', handleStorageChange);
    window.addEventListener('languageChanged', handleLanguageChange);

    return () => {
      window.removeEventListener('storage', handleStorageChange);
      window.removeEventListener('languageChanged', handleLanguageChange);
    };
  }, []);

  const jwt = useSelector(getJWT);
  const jwtToken = localStorage.getItem("jwt");

  useEffect(() => {
    if (loginAttemptSuccess === false) {
      // give toast notification
      toast(translations[languagepreference].incorrectUsernamePassword);

      // dispatch logout
      dispatch(brokerLoggedOut());
    }
  }, [loginAttemptSuccess, dispatch]);

  useEffect(() => {
    const onKeyPressed = (e) => {
      if (e.keyCode === 27) {
        dispatch(loginModalClosed());
      }
    };
    document.addEventListener("keydown", onKeyPressed);

    return () => {
      document.removeEventListener("keydown", onKeyPressed);
    };
  }, [dispatch]);

  const handleSignUp = async () => {
    dispatch(signUpModalOpened());
    if (signUp === true) {
      await dispatch(loginModalClosed());
    }
  };

  return (
    <React.Fragment>
      <div style={{ width: "100%", height: "100%" }}>
        <section
          className="text-center align-items-center"
          style={{
            display: "flex",
            position: "relative",
            height: "100%",
            backgroundColor: "#eef3f6",
          }}
        >
          <div className="container-fluid">
            <img
              src={quoteyLogo}
              className="quotey-logo"
              alt="quoteyrobo"
            ></img>
            <div className="row">
              <div className="custom-login-screen">
              <StytchB2BLogin />
                {/* <div className="p-2 login-card">
                  <div
                    className="p-5"
                    style={{
                      backgroundColor: "#f6fafd",
                      fontFamily: "GibsonRegular",
                    }}
                  >
                    <StytchB2BLogin />
                  </div>
                </div> */}
              </div>
            </div>
            <div style={{ marginTop: "5rem" }}>
              <Copyright languagepreference={languagepreference} />
            </div>
          </div>
        </section>
      </div>
      <div>
        <Modal
          isOpen={signUp}
          ariaHideApp={false}
          shouldCloseOnEsc={false}
          style={{
            overlay: {
              position: "fixed",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: theme.COLORS.rgba_primary_navyblue,
            },
            content: {
              height: "85vh",
              width: "62%",
              position: "absolute",
              margin: "0 auto",
              top: "7vh",
              left: "-1vw",
              right: 0,
              bottom: 0,
              background: theme.COLORS.tertiary_lightbackground,
              WebkitOverflowScrolling: "touch",
              border: "8px solid " + theme.COLORS.primary_navyblue,
              borderRadius: "20px",
              padding: 0,
              overflow: "hidden",
            },
          }}
        >
          <PerfectScrollbar>
            <div style={{ position: "absolute", top: 5, right: 5 }}>
              <CancelIcon
                fontSize="large"
                style={{ cursor: "pointer" }}
                onClick={() => {
                  dispatch(signUpModalClosed());
                }}
              ></CancelIcon>
            </div>
            <Sample />
          </PerfectScrollbar>
        </Modal>
      </div>
    </React.Fragment>
  );
};
function Copyright({ languagepreference }) {
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      {"Copyright © "}
      <Link color="inherit">Quotey</Link> {new Date().getFullYear()}
      {languagepreference === 'fr' ? ' | Tous droits réservés.' : ' | All Rights Reserved.'}
    </Typography>
  );
}
export default Login;
